import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { from, Subject } from 'rxjs';
import { HeadsComponent } from '../heads/heads.component';
import { LedgerRecordComponent } from '../ledger-record/ledger-record.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { VoucherEntryComponent } from '../voucher-entry/voucher-entry.component';
import { APIService } from './../api.service';
import { DataService } from "../services/data.service";
import { JsonPipe } from '@angular/common';
import { debug } from 'console';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { FinancialYearcountComponent } from '../financial-yearcount/financial-yearcount.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ImportledgerComponent } from '../inventory/importledger/importledger.component';
import { InvoiceStatusComponent } from  '../invoice-status/invoice-status.component'
import { ModuleTrainingComponent } from '../module-training/module-training.component';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {
  // @ViewChild(LedgerRecordComponent) ledgerChild: LedgerRecordComponent;

  @Input() changing: Subject<boolean> = new Subject();
  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();
  fromDate: Date = new Date("2021-Apr-01");
  toDate: Date = new Date("2022-Mar-31");

  initAcctDates = {
    fdt: new Date(),
    tdt: new Date(),
    selectedFy: (new Date()).getFullYear() + '-' + (new Date()).getFullYear()+1
  };
  accountDates: Subject<{
    fdt: Date,
    tdt: Date,
    selectedFy: String
  }> = new Subject();

  constructor(private modalService: NgbModal, private apiService: APIService, private appService: DataService,
    private router: Router, private commonService: CommonService, private loadingPnl: NgxSpinnerService) {
      this.accountDates.next({...this.initAcctDates});
  }
  innerWidth: any;
  isEditGSTLedger: boolean = false;
  isShowRVoucher: boolean = true;
  ledger: any = [];
  isShowRVoucherMob: boolean = false;
  isMobileView: boolean = false;
  isShowVoucherBtn: boolean = false;
  selectedObj: any = {};
  ledgers: any = [];
  GSTLedger = {
    CGSTOut: '',
    SGSTOut: '',
    IGSTOut: '',
    CGSTIn: '',
    SGSTIn: '',
    IGSTIn: '',
    CGSTRevOut: '',
    SGSTRevOut: '',
    IGSTRevOut: '',
  }
  jarvisData: any = [];
  acc: any;
  selectedFY: any;
  financialYears: any = [];
  ERP_Agn: Array<any> = [];
  acctStartDT: Date = new Date();
  isAdminUsers: boolean = false;
  right: any;
  objPeriod = {
    selectedPeriod: ''
  };

  isWeb: boolean = true;

  val: number = -1;
  isLedgerSet: boolean = false;
  isShowLogoutBtn: boolean = false;
  
  isShowAccount: boolean = false;
  relID: number = 0;
  showLearningMaterial: boolean = false;
  showOnBoarding: boolean = false;

  ngOnInit(): void {
    this.acc = true
    var jarvis = this.apiService.getCookie("Jarvis");
    let agencyData = this.apiService.getCookie("M");
    let tmpERP_cfg = this.apiService.getCookie('ERP_Cfg');
    let erpCount = this.apiService.getCookie('ERP_Cnts');
    let Cfg_AgnCfg = [];
    let erpCountData = [];
   
    if (tmpERP_cfg) {
      Cfg_AgnCfg = JSON.parse(tmpERP_cfg);
      if (Cfg_AgnCfg[0].GSTLedgers) {
        this.gstLedgerList = Cfg_AgnCfg[0].GSTLedgers;
      }
    }

    //ERP Count - Ledger Import time
    if (erpCount) {
      erpCountData = JSON.parse(erpCount);
      if (erpCountData.length > 0) {
        if(erpCountData[0].CntLedgers == 0){
          this.isLedgerSet = true;
        }
        else if(erpCountData[0].CntLedgers == 10 && this.gstLedgerList.length != 0){
          this.isLedgerSet = true;
        }
      }
    }

    if (this.apiService.checkIsPremiumOrTrial() == false){
      if (this.apiService.fn_isLiveURL() == true)
      {
        window.location.href = "https://biziverse.com/main.html#/home";
        return;
      }
      else{
        window.location.href = "main.html#/home";
        return;
      }    
    }
     

    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      var PremiumTillDT = this.agencyData[0].PremiumTillDT;
      if (new Date(PremiumTillDT) < new Date() || !PremiumTillDT || PremiumTillDT == null) {
        // if (this.apiService.fn_isLiveURL() == true)
        // {
        //   window.location.href = "https://biziverse.com/main.html#/home";
        //   return;
        // }
        // else{
        //   window.location.href = "main.html#/home";
        //   return;
        // }          
      }
    }

    this.isWeb = this.apiService.apiCheckWeb();

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }

    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }
    // alert("This feature is under development. Expected to be released in April 2021.");


    if (jarvis == 'undefined' || jarvis == undefined || jarvis == null) {
      window.location.href = '../../';
    }

    this.appService.favLedgerData.subscribe((value: any) => {
      this.ledgers = value;
    });

    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    this.right = this.apiService.getCookie("J");
    if (this.right) {
      this.right = JSON.parse(this.right);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.right = $.grep(this.right, function (o: any) { return o.UserID == ownUserID })[0];
      if (!this.right.Accts && !this.right.AcctsVchrEntry && !this.right.AcctsCfg) { // && (this.apiService.checkBzvzEdition() != 4)
        if (this.apiService.fn_isLiveURL() == true)
        {
          window.location.href = "https://biziverse.com/main.html#/home";
          return;
        }
        else{
          window.location.href = "main.html#/home";
          return;
        }       
      }
    }
    else{
      if (this.apiService.fn_isLiveURL() == true)
      {
        window.location.href = "https://biziverse.com/main.html#/home";
        return;
      }
      else{
        window.location.href = "main.html#/home";
        return;
      }  
    }

    if(this.agencyData[0].AdminUserID == this.jarvisData[0].UserID){
      this.isAdminUsers = true;
    }

    this.getGSTLedgers();

    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    this.showLearningMaterial = this.commonService.checkShowLearningMaterial();
    this.showOnBoarding = this.commonService.checkShowOnBoarding();

    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.selectedFY = accountsDate[0].selectedFy;
    //     //this.selectedFY = accountsDate[0].selectedFy;
    //     var toDate1 = accountsDate[0].tdt;
    //     this.toDate = toDate1.replace(/%20/g, " ");
    //     this.fromDate = accountsDate[0].fdt;
    //   }
    //   else {
    //     this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //   }
    // }
    // else {
    //   this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    // }
    
    // To Fix
    this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    
    this.getDates();
    this.isShowLogoutBtn = (this.apiService.checkBzvzEdition() == 4 ? true : false);

    this.appService.tmpFinancialYearChange.subscribe(v => {
      if (v == 1) {
        this.getDates();
      }
    });  
    this.isShowAccount = this.apiService.checkFeatureAccess('accounts');
    if(!this.isShowAccount){
      window.location.href = "https://biziverse.com/main.html#/home";
    };

    this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1000) {
            this.isMobileView = true;
        }
  }

  closeResult: any;
  modalReference: any;
  agencyData: any;
  gstLedgerList: any = [];

  //getGSTLedgers() - GST Ledgers Get
  getGSTLedgers(){
    let tmpERP_cfg = this.apiService.getCookie('ERP_Cfg');
    let Cfg_AgnCfg = [];
    if (tmpERP_cfg) {
      Cfg_AgnCfg = JSON.parse(tmpERP_cfg);
      if (Cfg_AgnCfg[0].GSTLedgers) {
        this.gstLedgerList = Cfg_AgnCfg[0].GSTLedgers;
      }
    }

    this.gstLedgerList = [];
    // // This section for multi GST
    // let tmpSelectedGST = this.gstLedgerList.filter((o: any) => o.GST == this.gstINLocation);
    // this.gstLedgerList = [];
    // if(tmpSelectedGST.length > 0){
    //   if(tmpSelectedGST[0].GSTLedgers){
    //     this.gstLedgerList = JSON.parse(tmpSelectedGST[0].GSTLedgers);
    //   }
    // }
    
    if (this.gstLedgerList.length > 0) {
      this.GSTLedger.CGSTOut = this.gstLedgerList[0].ledgerName;
      this.GSTLedger.SGSTOut = this.gstLedgerList[1].ledgerName;
      this.GSTLedger.IGSTOut = this.gstLedgerList[2].ledgerName;
      this.GSTLedger.CGSTIn = this.gstLedgerList[3].ledgerName;
      this.GSTLedger.SGSTIn = this.gstLedgerList[4].ledgerName;
      this.GSTLedger.IGSTIn = this.gstLedgerList[5].ledgerName;

      if (this.gstLedgerList.length > 6) {
        this.GSTLedger.CGSTRevOut = this.gstLedgerList[6].ledgerName;
        this.GSTLedger.SGSTRevOut = this.gstLedgerList[7].ledgerName;
        this.GSTLedger.IGSTRevOut = this.gstLedgerList[8].ledgerName;
      }

      if(this.isAdminUsers) {
        this.isEditGSTLedger = false;
      }
      else {     
        this.isEditGSTLedger = true;
      }
    }
  }

  open(content: any) {
    // window.open("/voucher", '_blank', 'height = 385, width = 900');

    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    //       this.closeResult = `Closed with: ${result}`;
    //   }, (reason) => {
    //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public closeModal($event: any) {
    this.modalReference.close();
    if ($event) {
      this.changingValue.next($event);
      this.changingHeadValue.next($event);
    }
  }

  getDates(){
    // let accountsDate: any = this.apiService.getCookie("AccountsDates");
    // if (accountsDate) {
    //   accountsDate = JSON.parse(accountsDate);
    //   if (accountsDate.length > 0) {
    //     this.selectedFY = accountsDate[0].selectedFy;
    //     //this.selectedFY = accountsDate[0].selectedFy;
    //     var toDate1 = accountsDate[0].tdt;
    //     this.toDate = toDate1.replace(/%20/g, " ");
    //     this.fromDate = accountsDate[0].fdt;
    //   }
    //   else {
    //     this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    //   }
    // }
    // else {
    //   this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    // }
    if(this.accountDates){
      // this.selectedFY = this.accountDates.selectedFy;
      // this.toDate = this.accountDates.tdt;
      // this.fromDate = this.accountDates.fdt;
      this.accountDates.subscribe(dates => {
        this.selectedFY = dates.selectedFy;
        this.fromDate = dates.fdt;
        this.toDate = dates.tdt;
      })
    }
    else{
      this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
    }
  }


  GSTLedgerModal(gstLedgerSelect: any) {
    this.getGSTLedgers();
    this.modalReference = this.modalService.open(gstLedgerSelect, { windowClass: "gstSelectModal", backdrop: 'static', keyboard: false });
  }

  onChange() {
    this.selectedObj = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.CGSTOut);
  }

  saveGSTLedger() {
    if (String(this.GSTLedger.CGSTOut).trim() == '') {
      this.apiService.successAlert('Please select CGSTOut.');
      return;
    }
    else if (String(this.GSTLedger.SGSTOut).trim() == '') {
      this.apiService.successAlert('Please select SGSTOut.');
      return;
    }
    else if (String(this.GSTLedger.IGSTOut).trim() == '') {
      this.apiService.successAlert('Please select IGSTOut.');
      return;
    }
    else if (String(this.GSTLedger.CGSTIn).trim() == '') {
      this.apiService.successAlert('Please select CGSTIn.');
      return;
    }
    else if (String(this.GSTLedger.SGSTIn).trim() == '') {
      this.apiService.successAlert('Please select SGSTIn.');
      return;
    }
    else if (String(this.GSTLedger.IGSTIn).trim() == '') {
      this.apiService.successAlert('Please select IGSTIn.');
      return;
    }
    else if (String(this.GSTLedger.CGSTRevOut).trim() == '') {
      this.apiService.successAlert('Please select CGST Reverse Ledger.');
      return;
    }
    else if (String(this.GSTLedger.SGSTRevOut).trim() == '') {
      this.apiService.successAlert('Please select SGST Reverse Ledger.');
      return;
    }
    else if (String(this.GSTLedger.IGSTRevOut).trim() == '') {
      this.apiService.successAlert('Please select IGST Reverse Ledger.');
      return;
    }

    else {
      let tmpArry = [];

      let CGSTOut = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.CGSTOut);
      tmpArry.push({
        id: 1,
        ledgerID: CGSTOut.LedgerID,
        type: 'CGST-Out',
        ledgerName: CGSTOut.LedgerName
      });

      let SGSTOut = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.SGSTOut);
      tmpArry.push({
        id: 2,
        ledgerID: SGSTOut.LedgerID,
        type: 'SGST-Out',
        ledgerName: SGSTOut.LedgerName
      });

      let IGSTOut = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.IGSTOut);
      tmpArry.push({
        id: 3,
        ledgerID: IGSTOut.LedgerID,
        type: 'IGST-Out',
        ledgerName: IGSTOut.LedgerName
      });

      let CGSTIn = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.CGSTIn);
      tmpArry.push({
        id: 4,
        ledgerID: CGSTIn.LedgerID,
        type: 'CGST-In',
        ledgerName: CGSTIn.LedgerName
      });

      let SGSTIn = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.SGSTIn);
      tmpArry.push({
        id: 5,
        ledgerID: SGSTIn.LedgerID,
        type: 'SGST-In',
        ledgerName: SGSTIn.LedgerName
      });

      let IGSTIn = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.IGSTIn);
      tmpArry.push({
        id: 6,
        ledgerID: IGSTIn.LedgerID,
        type: 'IGST-In',
        ledgerName: IGSTIn.LedgerName
      });

      let CGSTRev = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.CGSTRevOut);
      tmpArry.push({
        id: 7,
        ledgerID: CGSTRev.LedgerID,
        type: 'CGST-ReverseChg-Out',
        ledgerName: CGSTRev.LedgerName
      });

      let SGSTRev = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.SGSTRevOut);
      tmpArry.push({
        id: 8,
        ledgerID: SGSTRev.LedgerID,
        type: 'SGST-ReverseChg-Out',
        ledgerName: SGSTRev.LedgerName
      });

      let IGSTRev = this.ledgers.find((l: any) => l.LedgerName == this.GSTLedger.IGSTRevOut);
      tmpArry.push({
        id: 9,
        ledgerID: IGSTRev.LedgerID,
        type: 'IGST-ReverseChg-Out',
        ledgerName: IGSTRev.LedgerName
      });

      let obj = [{
        ChangeType: 'GSTLDG',
        CfgGSTLedgers: JSON.stringify(tmpArry)
      }];

      let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,

        actionType: 'set',
        moduleID: 4,
        data: JSON.stringify(obj)
      }];

      this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));

    }
  }

  resetGSTModal() {
    this.GSTLedger.CGSTOut = '';
    this.GSTLedger.SGSTOut = '';
    this.GSTLedger.IGSTOut = '';
    this.GSTLedger.CGSTIn = '';
    this.GSTLedger.SGSTIn = '';
    this.GSTLedger.IGSTIn = '';
    this.GSTLedger.CGSTRevOut = '';
    this.GSTLedger.SGSTRevOut = '';
    this.GSTLedger.IGSTRevOut = '';
  }

  successEntry(res: any) {
    // this.SpinnerService.hide();
    if (res.error) {
      this.apiService.successAlert(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table1) {
          let coockieData = [];
          coockieData.push(ErpData.Table1[0]);
          let ErpAgn = JSON.stringify(coockieData);
          localStorage.setItem("ERP_Agn", ErpAgn)
        }
        if (ErpData.Table2) {
          let cookieData2 = [];
          cookieData2.push(ErpData.Table2[0]);
          let ErpCfgData = JSON.stringify(cookieData2);
          localStorage.setItem("ERP_Cfg", ErpCfgData);
        }
      }

      this.modalReference.close();
      this.resetGSTModal();
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    // this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  backBtn() {
    this.apiService.setCookie("slectedHeadID", 0);
    this.apiService.setCookie("slectedLeaderID", 0);
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP"
    }
    urlCheck += "/accounts"
    window.open(urlCheck, "_self");
    //window.history.back();
  }

  //fn_changeFinancialYear() - Date Changes
  fn_changeFinancialYear($event: any) {
    if (this.selectedFY != 'Other') {
      let selectedYear = String(this.selectedFY).split("-");
      let accountDate: Array<any> = [{
        fdt: '1-Apr-' + selectedYear[0],
        tdt: '31-Mar-' + selectedYear[1],
        selectedFy: this.selectedFY
      }];
      this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
      this.accountDates.next({...accountDate[0]});

      this.changing.next($event);
      this.changingHeadValue.next($event);
    }
    else {
      this.fn_openDateChangeModal($event);
    }
    this.modalReference.close();

  }

  //fn_openDateChangeModal() - Change Modal
  fn_openDateChangeModal($event: any) {
    this.modalReference = this.modalService.open(FinancialYearcountComponent, { windowClass: "fycount", backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    // let dateData: object = {
    //   fromDT: this.fromDate,
    //   toDT: this.toDate
    // }
    // this.modalReference.componentInstance.LedgerRecordData = dateData;

    this.modalReference.result.then((result: any) => {
      if (result) {
        let accountDate: Array<any> = [{
          fdt: new Date(result.fromDT).customFormat('#DD#-#MMM#-#YYYY#'),
          tdt: new Date(result.toDT).customFormat('#DD#-#MMM#-#YYYY#'),
          selectedFy: 'Other'
        }];
        this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
        this.accountDates.next({...accountDate[0]});
        this.changingValue.next($event);
        this.changingHeadValue.next($event);
      }

    });
  }

  fn_ChangeDate() {

    // Here Set Accounting Year of Selected Date
    var Date2 = new Date(this.fromDate);
    var Date1 = new Date(this.toDate);
    var acctStartDT = new Date(this.acctStartDT);
    let CurrentDate = new Date();

    if (Date1 < acctStartDT) {
      this.apiService.successAlert("Please select date after " + this.acctStartDT.customFormat("#DD#-#MMM#-#YY#"));
      this.fn_Set_FinancialYear(CurrentDate);
      return;
    }

    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      Date2 = new Date(Year + "/04/01");
      //this.fromDate = new Date(Year + "/04/01");
      //$scope.ToDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      Date2 = new Date(Date1.getFullYear() + "/04/01");
      //this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      // $scope.ToDate = new Date(Year + "/03/31");
    }

    //fn_HeadSummary();

    let accountDate: Array<any> = [{
      fdt: new Date(this.fromDate).customFormat("#DD#-#MMM#-#YY#"),
      tdt: new Date(this.toDate).customFormat("#DD#-#MMM#-#YY#"),
      selectedFy: this.selectedFY
    }];
    this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
    this.accountDates.next({...accountDate[0]});
    //fn_Set_FinancialYear($scope.ToDate); 
  }

  // ddlchangeYear() {
  //   if (this.selectedFY != 'Other') {
  //     let selectedYear;
  //     selectedYear = this.selectedFY.split("-")[0] + "";
  //     let toDate = (Number(selectedYear) + 1) + "/03/31";
  //     //this.selectedDate = toDate;

  //     let accountDate: Array<any> = [{
  //       fdt: '1-Apr-' + selectedYear[0],
  //       tdt: '31-Mar-' + selectedYear[1],
  //       selectedFy: this.selectedFY
  //     }];
  //     this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
  //     this.fn_Set_FinancialYear(toDate);
  //   }
  // }

  fn_Set_FinancialYear(ToDT: any) {

    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }

  }

  openNewWindowVoucher($event: any){  
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
    
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    var win: any = window.open(urlCheck, target, 'height = 600, width = 1250');
    var timer = setInterval(() => {

      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          this.changingValue.next($event);
          this.changingHeadValue.next($event);
          this.changing.next($event);
          if(win.updateData){
            if(win.updateData.length > 0){
              if(win.updateData[0].isUpdateInvoice == true){
                this.relID = win.updateData[0].relID;
                if(this.relID > 0){
                  this.invInvoiceStatusUpdate();
                }
              }
            }
          }
          win.close();
        }
      }

      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
  }

  refreshPeriod($event: any) {
    this.fn_openDateChangeModal($event);
  }

  backToHomeBtn() {
    window.location.href = "https://biziverse.com/main.html#/home";
  }

  filterApply(content: any){
    // let accountDate = this.apiService.getCookie("AccountsDates");
    // if (accountDate) {
    //   let accountsDate = JSON.parse(accountDate);
    //   if (accountsDate.length > 0) {
    //     if (accountsDate[0].selectedFy == 'Other') {
    //       this.fromDate = new Date(accountsDate[0].fdt);
    //       this.toDate = new Date(accountsDate[0].tdt);
    //     }
    //     else{
    //       this.financialYears = this.commonService.checkFinancialYear(new Date("2021"), new Date());
    //       this.selectedFY = accountsDate[0].selectedFy; //this.financialYears[this.financialYears.length - 1].FY;

    //       localStorage.setItem("periods", this.selectedFY);
    //       let currentDate = new Date();
    //       this.fn_Set_FinancialYear(currentDate);
         
    //     }
    //   }
    // }
    if(this.accountDates){
      this.accountDates.subscribe(dates => {
        if(dates.selectedFy == 'Other'){
          this.fromDate = new Date(dates.fdt);
          this.toDate = new Date(dates.tdt);
        }
        else{
          this.financialYears = this.commonService.checkFinancialYear(new Date("2021"), new Date());
          this.selectedFY = dates.selectedFy; //this.financialYears[this.financialYears.length - 1].FY;
  
          localStorage.setItem("periods", this.selectedFY);
          let currentDate = new Date();
          this.fn_Set_FinancialYear(currentDate);
        }
      })
    }
    
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'dateFilter', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  changePeriod(obj: any, i: number){
    this.val = i;
    this.objPeriod.selectedPeriod = obj;
    this.selectedFY = obj;
    if(obj != 'Other'){
      this.fn_changeFinancialYear(obj)
    }
    else{     
      let nextYear: number = new Date().getFullYear() + 1;
      let currYear: number = new Date().getFullYear();

      if(new Date().getMonth() < 3){
        nextYear = new Date().getFullYear();
        currYear = new Date().getFullYear() -1;
      }
      else{
        nextYear = new Date().getFullYear() + 1;
        currYear = new Date().getFullYear();
      }

      this.fromDate = new Date('1-Apr-' + currYear);
      this.toDate = new Date('31-Mar-' + nextYear);
    }
  }

  serach($event: any) {  
    let obj = {
      fromDT: this.fromDate,
      toDT: this.toDate,
    }

    let accountDate: Array<any> = [{
      fdt: new Date(this.fromDate).customFormat('#DD#-#MMM#-#YYYY#'),
      tdt: new Date(this.toDate).customFormat('#DD#-#MMM#-#YYYY#'),
      selectedFy: 'Other'
    }];
    this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
    this.accountDates.next({...accountDate[0]});
    this.changing.next($event);
    this.changingValue.next($event);
    this.changingHeadValue.next($event);
    this.modalReference.close();
  }

  importLadger(){
    this.modalReference = this.modalService.open(ImportledgerComponent,{ ariaLabelledBy: 'modal-basic-title', windowClass: 'modalWidthSmallLedgerAdd', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.result.then((result: any) => {
      if (result.action == 'Done') {
        window.location.reload();
      }
    });
  }

  invInvoiceStatusUpdate(){
    this.modalReference = this.modalService.open(InvoiceStatusComponent,{ ariaLabelledBy: 'modal-basic-title', windowClass: '', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.relID = this.relID;
    this.modalReference.result.then((result: any) => {
      // if (result.action == 'Done') {
      //   window.location.reload();
      // }
    });
  }

//User List Color
changeColorUserList(ind: any, fyList: number){
  var clr = ""    
  clr = fyList == this.selectedFY ? 'bz-drkBlueBtn-lb-active' : 'bz-drkBlueBtn-lb';
  return clr;
}

  //logOut() - logout Function
  logOut = () => {
    this.apiService.swalConfirm("Are you sure you wish to logout?", () => {
      this.apiService.resetEverthing();  
      // localStorage.clear();
        if(this.apiService.fn_isLiveURL()){
          window.location.href = 'https://biziverse.com/';
        }
        else{
          window.location.href = 'http://localhost:60228/index.html';
        }
    });

   
}

// Open Help Page
openHelpPage(id: any) {
  this.commonService.openModulHelp(id, this.isWeb);
}
  
  openTrngModal = () => {
    this.appService.trainingVideoActions('active', 9);
    this.modalReference = this.modalService.open(ModuleTrainingComponent, { windowClass: "modal-suggest-profile", backdrop: 'static', keyboard: false });
  }
}

declare global {
  interface Date {
    customFormat(formatString: any): string;
  }
}

// String Prototye
Date.prototype.customFormat = function (formatString: any) {
  var YYYY, YY, MMMM, MMM, MM, M, DDDD, DDD, DD, D, hhhh, hhh, hh, h, mm, m, ss, s, ampm, AMPM, dMod, th;
  YY = ((YYYY = this.getFullYear()) + "").slice(-2);
  MM = (M = this.getMonth() + 1) < 10 ? ('0' + M) : M;
  MMM = (MMMM = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][M - 1]).substring(0, 3);
  DD = (D = this.getDate()) < 10 ? ('0' + D) : D;
  DDD = (DDDD = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][this.getDay()]).substring(0, 3);
  th = (D >= 10 && D <= 20) ? 'th' : ((dMod = D % 10) == 1) ? 'st' : (dMod == 2) ? 'nd' : (dMod == 3) ? 'rd' : 'th';
  formatString = formatString.replace("#YYYY#", YYYY).replace("#YY#", YY).replace("#MMMM#", MMMM).replace("#MMM#", MMM).replace("#MM#", MM).replace("#M#", M).replace("#DDDD#", DDDD).replace("#DDD#", DDD).replace("#DD#", DD).replace("#D#", D).replace("#th#", th);
  h = (hhh = this.getHours());
  if (h == 0) h = 24;
  if (h > 12) h -= 12;
  hh = h < 10 ? ('0' + h) : h;
  hhhh = h < 10 ? ('0' + hhh) : hhh;
  AMPM = (ampm = hhh < 12 ? 'am' : 'pm').toUpperCase();
  mm = (m = this.getMinutes()) < 10 ? ('0' + m) : m;
  ss = (s = this.getSeconds()) < 10 ? ('0' + s) : s;
  return formatString.replace("#hhhh#", hhhh).replace("#hhh#", hhh).replace("#hh#", hh).replace("#h#", h).replace("#mm#", mm).replace("#m#", m).replace("#ss#", ss).replace("#s#", s).replace("#ampm#", ampm).replace("#AMPM#", AMPM);
}





